import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=6cfd73bc&scoped=true"
import script from "./Perfil.vue?vue&type=script&lang=ts"
export * from "./Perfil.vue?vue&type=script&lang=ts"
import style0 from "./Perfil.vue?vue&type=style&index=0&id=6cfd73bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd73bc",
  null
  
)

export default component.exports